// import React from "react";
import "../../index.css";
// import { Tickets } from "./support_tray_tab/Tickets.jsx";
// import { Knowledge } from "./support_tray_tab/Knowledge.jsx";
//import { Contact } from "./support_tray_tab/Contact.jsx";
import { ChangeCalendar } from "./support_tray_tab/ChangeCalendar.jsx";
import { Button } from '@fluentui/react-northstar';
import  Announcement  from "./support_tray_tab/Announcement.jsx";
import { Assets } from "./support_tray_tab/Assets";
import { Tickets } from "./support_tray_tab/Tickets";
import { Knowledge } from "./support_tray_tab/Knowledge";
import { Settings } from "./support_tray_tab/Settings";
import React, { useContext, useState, useEffect } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';
import { TeamsFx } from "@microsoft/teamsfx";

function extractArrayFromData(data){
    if(Array.isArray(data)) return data;

    const possiblekeys = Object.keys(data || {});

    for (const key of possiblekeys){
        if(Array.isArray(data[key])){
            return data[key];
        }
    }

    return[];
}
export function SupportTrayTab() {
    const [selected, setSelected] = useState(false);
    const [dataFromChild1, setDataFromChild1] = useState('');
    const [dataFromChild2, setDataFromChild2] = useState(null);
    const [unreadCount, setUnreadCount] = useState(0);
    const reactFunctionEndpoint= process.env.REACT_APP_FUNCTION_ENDPOINT;
    const resource_apiendpoint = reactFunctionEndpoint.split("://")[1];
    const reactClientId= process.env.REACT_APP_CLIENT_ID;
    const scopes = `api://${resource_apiendpoint}/${reactClientId}/.default`;

    const [accessToken, setAccessToken]= useState(null);
   
    
    const handleDataFromChild = (showJokes, jokeData) => {
        setDataFromChild1(showJokes);
        setDataFromChild2(jokeData);
    };
    

    const tabData = [
        {
            name: "Announcement",
            id: 1
        },
        {
            name: "Knowledge",
            id: 2
        },
        {
            name: "Tickets",
            id: 3
        },
        /* {
            name: "Contact",
            id: 4
        }, */
        {
            name: "Change Calendar",
            id: 4
        },
        {
            name: "Asset",
            id: 5
        },
        {
            name: "Settings",
            id: 6
        }
    ];

    const [currentTab, setCurrentTab] = React.useState(0);
    const TipoftheDayURL = `${reactFunctionEndpoint}/api/getServiceNowAPIData?type=tipoftheday`;
    const [tip, setTip] = useState([]);
    const [rawData, setRawData] = useState([]);

    useEffect(()=> {
        const fetchToken = async() =>{
        try{
            await microsoftTeams.app.initialize();
            const ssoToken =await microsoftTeams.authentication.getAuthToken();
            setAccessToken(ssoToken);
        } catch (err){
            console.err("Token check error: ", err);
        }
        };
        fetchToken();
    },[]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(TipoftheDayURL,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accessToken}`,
                            },
                        }
                    );
                //const tip_parse = typeof response.data ==="string" ? JSON.parse(response.data) : response.data;
                const resp_json = await response.json();

/*                 console.log("typeof data: ", typeof resp_json);
                console.log("isArray: ", Array.isArray(resp_json));
                console.log("keys: ", Object.keys(resp_json)); */

                setRawData(resp_json);
                const extracted = extractArrayFromData(resp_json);                
                setTip(extracted);
                /* if (Array.isArray(tip_parse)){
                    setTip(tip_parse);
                } else if (Array.isArray(tip_parse.result)){
                    setTip(tip_parse.result);
                } else { console.warn("Unexpected response shape: ", tip_parse);} */
                //setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
               // setLoading(false);
            }
        };
        fetchData();
    }, [accessToken]);
    
    const handleClick = (currentTab) => {
        setCurrentTab(currentTab);
    }

    return (
        <div>
            <div className="flexRow">
                <div className="tab">
                    {tabData.map((button, i) => (
                        <div key={button.name}>
                            <Button
                                content={button.name} key={button.name} 
                                className={`tablinks ${currentTab === i ? "active":""}`} 
                                onClick={() => handleClick(i)}
                                >
                                {button.name} {button.name === 'Announcement' && unreadCount>0 &&(
                                    <span style={{
                                        backgroundColor:'#ffc72c',borderRadius: '12px',color:'#425563',padding:'0px 6px', fontSize: '13px',textAlign:'center',fontWeight:'bolder',lineHeight:1
                                }}
                                >{unreadCount}
                                </span>
                                )}
                            </Button>
                        </div>
                    )
                    )
                    }
                    <div className='clearfix'></div>
                    <div className="tip-description">

                    {tip.length>0?(
                    tip.map((val, key) => (
                            <div key={key}>
                                <b>Tip of the day</b>
                                <p>{val.tipoftheDay}</p>
                                <a href={val.tipoftheURL} target="blank" rel="noopener noreferrer">Click to read more</a>
                            </div>
                        ))):(<p> </p>)}
                    </div>
                </div>

                <div className="tabcontent">
                    {currentTab === 0 &&
                        <>
                            <Announcement unreadCount={unreadCount} setUnreadCount={setUnreadCount}/>
                        </>
                    }
                    {currentTab === 1 &&
                        <>
                            <Knowledge />
                        </>
                    }
                    {currentTab === 2 &&
                        <>
                            <Tickets />
                        </>
                    }

                    {currentTab === 3 &&
                        <>
                            <ChangeCalendar />
                        </>
                    }
                    {currentTab === 4 &&
                        <>
                            <Assets />
                        </>
                    }
                    {currentTab === 5 &&
                        <>
                            <Settings />
                        </>
                    }
                </div>
            </div>
        </div>

    );
}
